// helper: convert markdown-like **...** into <b>...</b>
export const renderMessageWithBold = (text) => {
    const parts = text?.split(/(\*\*.*?\*\*)/g); // split by **...**
    return parts?.map((part, index) => {
        if (part?.startsWith('**') && part?.endsWith('**')) {
            return <b key={index}>{part?.slice(2, -2)}</b>;
        }
        return <span key={index}>{part}</span>;
    });
};
